import { Box, Flex, Image, Paper, Text, Title } from '@mantine/core';
import React from 'react';

import { SyncingIndicator } from '@components';
import { HelpCategoryItem, HelpDataConfig, HelpSectionEnum } from './helpData';

interface CategoryItemProps {
  item: HelpCategoryItem;
  fullWidth?: boolean;
}

const CategoryItem: React.FC<CategoryItemProps> = ({ item, fullWidth }) => {
  const { animationType, icon, text } = item;

  const renderAnimation = () => {
    if (animationType === 'syncing') {
      return <SyncingIndicator />;
    }
    return null;
  };

  const renderIcon = () => {
    if (!icon) return null;

    if (typeof icon === 'string') {
      return <Image src={icon as string} alt={text} maw={21} mah={21} />;
    }

    return (
      <Box maw={21} mah={21}>
        {icon}
      </Box>
    );
  };

  return (
    <Flex align="center" w={fullWidth ? 'auto' : '285px'}>
      {renderAnimation()}
      {renderIcon()}
      <Text fz={13} ml={20}>
        {text}
      </Text>
    </Flex>
  );
};

interface HelpSectionProps extends HelpDataConfig {
  sectionTitle: HelpSectionEnum;
}

export const HelpSection: React.FC<HelpSectionProps> = ({ sectionTitle, data, subsections, flexRow, fullWidth }) => {
  return (
    <Paper withBorder p="xl">
      <Title order={4}>{sectionTitle}</Title>

      {data && (
        <Flex direction={flexRow ? 'row' : 'column'} wrap="wrap" rowGap={27} columnGap={60} pt={20}>
          {data.map((item, idx) => (
            <CategoryItem key={idx} item={item} fullWidth={fullWidth} />
          ))}
        </Flex>
      )}

      {subsections?.map((subsection, subIdx) => (
        <div key={subIdx}>
          <Title order={5} mt={50}>
            {subsection.title}
          </Title>
          <Flex direction="row" wrap="wrap" rowGap={27} columnGap={60} pt={20}>
            {subsection.data.map((item, itemIdx) => (
              <CategoryItem key={itemIdx} item={item} />
            ))}
          </Flex>
        </div>
      ))}
    </Paper>
  );
};
